import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "./Gallery.css";

const websiteRenderNames = [
  "render1.png",
  "render15.jpeg",
  "render16.jpeg",
  "render17.jpeg",
  "render18.jpeg",
  "render19.png",
  "render2.png",
  "render23.png",
  "render24.png",
  "render25.png",
  "render26.png",
  "render27.png",
  "render28.png",
  "render3.png",
  "render30.jpeg",
  "render31.png",
  "render34.jpeg",
  "render35.jpeg",
  "render36.png",
  "render37.png",
  "render38.png",
  "render4.png",
  "render40.jpeg",
  "render41.png",
  "render42.png",
  "render43.png",
  "render44.png",
  "render45.png",
];

// Add each category's image filenames here as assets are placed in its public folder.
const categories = [
  {
    title: "Halo Renders",
    folder: "/gallery/halo",
    images: [
      "1.png",
      "2.png",
      "3.png",
      "4.png",
      "5.png",
      "6.png",
      "7.png",
      "8-old.png",
      "9.png",
      "10.png",
      "11.png",
      "12.png",
      "13.png",
      "14.png",
      "15.png",
      "16.png",
      "17.png",
      "18.png",
      "19.png",
    ],
  },
  {
    title: "Coco Retreat",
    folder: "/gallery/coco",
    images: ["1.png", "2.jpeg", "3.jpeg", "4a.jpg", "5.jpg", "6.jpg", "7.jpg"],
  },
  {
    title: "408 Eplanade",
    folder: "/gallery/408",
    images: [
      "1.jpg",
      "2.jpg",
      "3.jpg",
      "4.jpg",
      "5.png",
      "6.png",
      "7.png",
      "8.png",
      "9.png",
      "10.png",
      "11.png",
      "12.png",
      "13.png",
      "14.png",
      "15.png",
      "16.png",
      "17.png",
      "18.png",
      "19.png",
    ],
  },
  {
    title: "Metaluxe Website Renders",
    folder: "/images/renders",
    images: websiteRenderNames,
  },
];

const slides = categories.flatMap((category, categoryIndex) => {
  const images = category.images.length ? category.images : [null];
  return images.map((filename) => ({
    category,
    categoryIndex,
    filename,
    src: filename ? `${category.folder}/${filename}` : null,
  }));
});

const categoryStartIndices = categories.map((_, categoryIndex) =>
  slides.findIndex((slide) => slide.categoryIndex === categoryIndex),
);

function Gallery() {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const currentSlide = slides[activeSlide] || slides[0];

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") sliderRef.current?.slickPrev();
      if (event.key === "ArrowRight") sliderRef.current?.slickNext();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const settings = {
    arrows: false,
    dots: false,
    infinite: slides.length > 1,
    fade: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: slides.length > 1,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  return (
    <main className="gallery-page" aria-label="Metaluxe image gallery">
      <Slider ref={sliderRef} {...settings} className="gallery-slider">
        {slides.map((slide, index) => (
          <div
            className="gallery-slide"
            key={`${slide.category.title}-${index}`}
          >
            {slide.src ? (
              <img
                src={slide.src}
                alt={`${slide.category.title} ${slide.filename}`}
              />
            ) : (
              <div className="gallery-empty-state">
                <span>
                  Collection {String(slide.categoryIndex + 1).padStart(2, "0")}
                </span>
                <p>Renders will appear here</p>
              </div>
            )}
          </div>
        ))}
      </Slider>

      <div className="gallery-shade" aria-hidden="true" />

      <nav className="gallery-categories" aria-label="Gallery categories">
        {categories.map((category, index) => (
          <button
            className={currentSlide.categoryIndex === index ? "is-active" : ""}
            type="button"
            key={category.title}
            onClick={() =>
              sliderRef.current?.slickGoTo(categoryStartIndices[index])
            }
          >
            <span className="gallery-category-number">
              {String(index + 1).padStart(2, "0")}
            </span>
            {category.title}
          </button>
        ))}
      </nav>

      <div className="gallery-controls">
        <button
          className="gallery-arrow"
          type="button"
          aria-label="Previous image"
          onClick={() => sliderRef.current?.slickPrev()}
        >
          <span aria-hidden="true">←</span>
        </button>
        <span className="gallery-count" aria-live="polite">
          {String(activeSlide + 1).padStart(2, "0")}
          <span className="gallery-count-divider">/</span>
          {String(slides.length).padStart(2, "0")}
        </span>
        <button
          className="gallery-arrow"
          type="button"
          aria-label="Next image"
          onClick={() => sliderRef.current?.slickNext()}
        >
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </main>
  );
}

export default Gallery;
